import {
  BoxGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Sett mesh — heavy fists + gold trim (OCP registry). */
export function createSettMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x2563eb : 0xdc2626;
  const bodyMat = new MeshStandardMaterial({ color: 0x1f2937, roughness: 0.55 });
  const trimMat = new MeshStandardMaterial({ color: 0xf59e0b, metalness: 0.65, roughness: 0.3 });
  const fistMat = new MeshStandardMaterial({ color: trim, roughness: 0.4 });

  const torso = new Mesh(new CylinderGeometry(0.95, 0.7, 2.4, 10), bodyMat);
  torso.position.y = 2.0;
  group.add(torso);

  const head = new Mesh(new SphereGeometry(0.5, 12, 12), bodyMat);
  head.position.y = 3.45;
  group.add(head);

  const belt = new Mesh(new BoxGeometry(1.5, 0.25, 0.9), trimMat);
  belt.position.y = 1.2;
  group.add(belt);

  const leftFist = new Mesh(new SphereGeometry(0.38, 10, 10), fistMat);
  leftFist.position.set(-1.05, 1.7, 0.35);
  group.add(leftFist);

  const rightFist = new Mesh(new SphereGeometry(0.38, 10, 10), fistMat);
  rightFist.position.set(1.05, 1.7, 0.35);
  group.add(rightFist);

  return group;
}
